module.exports = __webpack_public_path__ + "img/ctrl-ising-stub--i.dd7be095.svg";